<div class="custom-not-found-error d-flex flex-row justify-content-center align-items-center vw-100 vh-100">
    
    <div class="d-flex flex-column justify-content-center align-items-center mx-auto w-50 h-50">
        <div class="custom-not-found-error-code d-flex flex-row justify-content-center align-items-center align-middle">
            404
        </div>
        <div class="custom-not-found-error-message d-flex flex-column justify-content-center align-items-center text-center">
            <span class="mb-2">La página a la que intentas acceder no existe.</span>
            <a mat-raised-button class="custom-not-found-error-button" [routerLink]="['/home']">
                <span class="material-icons">keyboard_backspace</span>
                Volver a la página principal
            </a>
        </div>
    </div>
    
</div>
